import debounce from 'lodash/debounce'
import Component from '../core/Component'
import { query, queryAll } from '../utils/dom'
import { getScroll } from '../services/Viewport'

const STATES = {
    STICKY: 'is-sticky',
    OVERFLOWING: 'is-overflowing'
}

export default class FixedTable extends Component {
    constructor(element, options = {}) {
        super(element, options = {
            minTableHeightForSticky: 200,
            stickyEndOffset: 100,
            stickyGlobalClassActive: 'is-fixed-table-sticky'
        })

        this.ref = {
            table: null,
            tableWrap: null,
            sticky: null,
            //tyhle 3 mozno zrefktovoat a udelat obecne, aby vsecky bunky s "data-type='xx'" se naklonovaly do "data-type-container='xx'", ktery byl mimo tabulku v .FixedTable-clones
            cloneFixed: null,
            cloneFixedAndSticky: null,
            cloneSticky: null,
        }

        this.tableClones = {
            'fixed': null,
            'sticky': null,
            'fixedAndSticky': null
        }

        this.state = {
            documentTop: null,
            documentLeft: null,
            width: null,
            height: null,
            isSticky: false,
            canBecomeSticky: true|false
        }

        this.temp = {
            docFragment: null,
            tableClone: null
        }

        this.handleResizeDebounce = debounce(this.handleResize, 250)
        this.handleMutationDebounce = debounce(this.handleMutation, 250)
    }

    prepare() {
        setTimeout(() => {
            this.prepareTableForCloning()
            this.rebuildTableCloneAll()
            this.resize()

            this.attachScrollSync()

            window.addEventListener('resize', this.handleResizeDebounce)
            window.addEventListener('scroll', this.handleScroll)

            this.mutationObserver = new MutationObserver(this.handleMutationDebounce)
            this.mutationObserver.observe(this.ref.table, { characterData: true, childList: true, subtree: true })
        }, 0)
    }

    destroy() {
        window.removeEventListener('resize-x', this.handleResizeDebounce)
        window.removeEventListener('scroll', this.handleScroll)
        this.mutationObserver.disconnect()
    }

    handleMutation = () => {
        this.prepareTableForCloning()
        this.rebuildTableCloneAll()
        this.resize()
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = () => {
        if (isInActiveTab(this.element)) {
            return
        }
        this.checkSticky()
    }

    checkSticky() {
        if (!this.state.canBecomeSticky) {
            return
        }
        const attach = () => {
            this.element.classList.add(STATES.STICKY)
            this.state.isSticky = true
            this.ref.sticky.style.position = 'fixed'
            this.ref.sticky.style.top = '0'
            this.ref.sticky.style.left = `${this.state.documentLeft}`
            this.ref.sticky.style.width = `${this.state.width}px`

            document.documentElement.classList.add(this.options.stickyGlobalClassActive)
        }

        const detach = () => {
            this.element.classList.remove(STATES.STICKY)
            this.state.isSticky = false
            this.ref.sticky.style.position = ''
            this.ref.sticky.style.top = ''
            this.ref.sticky.style.left = ''
            this.ref.sticky.style.width = ''

            document.documentElement.classList.remove(this.options.stickyGlobalClassActive)
        }

        let shouldAttach = false
        if (getScroll().y > this.state.documentTop && getScroll().y < this.state.documentTop + this.state.height - this.options.stickyEndOffset) {
            shouldAttach = true
        }

        if (this.state.isSticky && !shouldAttach) {
            detach()
        } else if (!this.state.isSticky && shouldAttach) {
            attach()
        }
    }

    prepareTableForCloning() {
        queryAll('tr:first-child th, tr:first-child td, tr td:first-child, tr th:first-child', this.ref.table).forEach((element, index) => {
            element.setAttribute('data-ft-id', index)
        })
    }

    rebuildTableCloneAll() {
        this.rebuildTableClone('fixed')
        this.rebuildTableClone('sticky')
        this.rebuildTableClone('fixedAndSticky')
    }

    resizeTableCloneAll() {
        this.resizeTableClone('fixed')
        this.resizeTableClone('sticky')
        this.resizeTableClone('fixedAndSticky')
    }


    rebuildTableClone(cloneName = null) {
        if (!cloneName) {
            return
        }

        if (this.tableClones[cloneName]) {
            this.destroyCloneTable(cloneName)
        }
        this.tableClones[cloneName] = this.createTableClone(cloneName)

        if (cloneName === 'fixed') {
            this.ref.cloneFixed.appendChild(this.tableClones[cloneName])
        } else if (cloneName === 'sticky') {
            this.ref.cloneSticky.appendChild(this.tableClones[cloneName])
        } else if (cloneName === 'fixedAndSticky') {
            this.ref.cloneFixedAndSticky.appendChild(this.tableClones[cloneName])
        }
    }

    createTableClone(cloneName = null) {
        if (!this.temp.TableClone) {
            this.createTempTableClone()
        }

        const tableClone = this.temp.tableClone.cloneNode(true)

        if (cloneName === 'fixed') {
            queryAll('th:not([data-fixed]),td:not([data-fixed])', tableClone).forEach(node => {
                node.parentNode.removeChild(node)
            })
        } else if (cloneName === 'sticky') {
            queryAll('th:not([data-sticky]),td:not([data-sticky])', tableClone).forEach(node => {
                node.parentNode.removeChild(node)
            })
        } else if (cloneName === 'fixedAndSticky') {
            queryAll('th:not([data-sticky][data-fixed]),td:not([data-sticky][data-fixed])', tableClone).forEach(node => {
                node.parentNode.removeChild(node)
            })
        }

        return tableClone
    }

    destroyCloneTable(cloneName = null) {
        if (!cloneName) {
            return
        }

        this.tableClones[cloneName].parentNode.removeChild(this.tableClones[cloneName])
    }

    resizeTableClone(cloneName = null) {
        const clone = this.tableClones[cloneName]
        if (!clone) {
            return
        }
        queryAll('tr:first-child th, tr:first-child td, tr td:first-child, tr th:first-child', clone).forEach(element => {
            const srcElement = query(`[data-ft-id="${element.dataset.ftId}"]`, this.ref.table)
            const srcRect = srcElement.getBoundingClientRect()
            element.style.width = `${srcRect.width.toFixed(2)}px`
            element.style.height = `${srcRect.height.toFixed(2)}px`
        })
    }

    createTempTableClone() {
        this.temp.tableClone = this.ref.table.cloneNode(true)
        this.temp.docFragment = new DocumentFragment
        this.temp.docFragment.appendChild(this.temp.tableClone)

        queryAll('th:not([data-fixed]):not([data-sticky]),td:not([data-fixed]):not([data-sticky])', this.temp.tableClone).forEach(node => {
            node.parentNode.removeChild(node)
        })


        const removeNodeIfEmpty = node => {
            if (!node.innerText && node.children.length === 0) {
                node.parentNode.removeChild(node)
            }
        }

        queryAll('*', this.temp.tableClone).forEach(node => {
            removeNodeIfEmpty(node)
        })

        sanitizeTableClone(this.temp.tableClone)
    }

    clearTemp() {
        Object.keys(this.temp).forEach(key => {
            this.temp[key] = null
        })
    }

    resize() {
        this.stateBefore = {
            width: this.state.width,
            height: this.state.height
        }

        const rect = this.element.getBoundingClientRect()
        this.state = {
            ...this.state,
            documentTop: rect.top + getScroll().y,
            documentLeft: rect.left + getScroll().x,
            width: rect.width,
            height: rect.height,
            canBecomeSticky: rect.height > this.options.minTableHeightForSticky,
        }

        if (this.state.isSticky) {
            this.ref.sticky.style.left = `${this.state.documentLeft}`
            this.ref.sticky.style.width = `${this.state.width}px`
        }

        this.checkSticky()

        if (this.stateBefore.width !== this.state.width || this.stateBefore.height !== this.state.height) {
            this.resizeTableCloneAll()
        }


        if (this.ref.tableWrap.offsetWidth < this.ref.tableWrap.scrollWidth) {
            this.element.classList.add(STATES.OVERFLOWING)
        } else {
            this.element.classList.remove(STATES.OVERFLOWING)
        }
    }

    attachScrollSync() {
        const syncElements = queryAll('[data-scrollsync]')
        let scrollOrigin = null
        let timer = null

        syncElements.forEach(syncElement => {
            syncElement.addEventListener('scroll', event => {

                if (scrollOrigin && event.target !== scrollOrigin) {
                    return
                }

                scrollOrigin = event.target
                clearTimeout(timer)
                timer = setTimeout(() => {
                    if (!this.element) {
                        return
                    }
                    scrollOrigin = null
                }, 500)

                syncElements.forEach(syncElement => {
                    if (syncElement === scrollOrigin) {
                        return
                    }

                    // syncElement.scrollTop = scrollOrigin.scrollTop
                    syncElement.scrollLeft = scrollOrigin.scrollLeft
                })
            })
        })
    }
}


function sanitizeTableClone(clone) {
    queryAll('*', clone).forEach(element => {
        if (element.id) {
            element.id = ''
        }
    })
    return clone
}

function isInActiveTab(element) {
    const tabElement = element.closest('[data-ref="Tabs:item"]')
    return tabElement && !tabElement.classList.contains('is-active')
}




// WEBPACK FOOTER //
// ./components/FixedTable.js